import {AgentLicenseDto} from 'Agent/AgentInformation/api';
import agentApi from 'Agent/AgentInformation/api/agentsApi';
import {AgentLicenseActionType, changeAgentLicenses, getAgentLicenses} from 'Agent/AgentInformation/ducks/agents';
import {AsyncResult, Loaded} from 'Core/models/Async';
import {Link, Page} from 'Core/models/Page';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {mergeWithNextPage} from 'Shared/utilities/PageUtility';
import {prop} from 'Shared/utilities/prop';
import {getPageApiCallGenerator, PageFetchAction} from 'Shared/utilities/sagaApiGenerators';
import {changeRateGenerators, getRateGenerators, RateGeneratorActionType} from '../ducks/rateGenerator';

const getAgentLicensesFromApi = (action: ReturnType<typeof getAgentLicenses>) => {
  return PageFetchAction.match({
    Additional: additionalPage =>
      (mergeWithNextPage<AgentLicenseDto>(additionalPage) as unknown) as Promise<AsyncResult<Page<AgentLicenseDto>>>,
    Initial: () =>
      (agentApi.getAgentLicenses(
        action.payload.agentNumbers.map(prop('value')),
        action.payload.isNewYork,
        action.payload.encryptedIdentifier,
        action.payload.filter
      ) as unknown) as Promise<AsyncResult<Page<AgentLicenseDto>>>,
  })(action.payload);
};
function* getAgentLicensesSaga() {
  yield takeLatest(
    AgentLicenseActionType.GET_AGENT_LICENSES,
    getPageApiCallGenerator(getAgentLicensesFromApi, changeAgentLicenses)
  );
}

function* getRateGeneratorApi(action: ReturnType<typeof getRateGenerators>) {
  const result: AsyncResult<Link[]> = yield call(agentApi.getRateGenerators, action.payload.encryptedIdentifier);
  yield pipe(
    result,
    E.map(value => new Loaded(value)),
    E.fold(
      value => put(changeRateGenerators(value)),
      value => put(changeRateGenerators(value))
    )
  );
}
function* getRateGeneratorSaga() {
  yield takeLatest(RateGeneratorActionType.GET_RATE_GENERATORS, getRateGeneratorApi);
}

export default function*() {
  yield all([getAgentLicensesSaga(), getRateGeneratorSaga()]);
}
